<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 199 199">
    <title>hydro</title>
    <g id="Hydro">
      <path
        class="cls-1"
        d="M188,137.35c-15.29,0-30.58-5.23-44-14.79-26.84,19-61.16,19-88,0-13.42,9.57-28.71,14.79-44,14.79"
      />
      <path
        class="cls-1"
        d="M188,161.35c-15.29,0-30.58-5.23-44-14.79-26.84,19-61.16,19-88,0-13.42,9.57-28.71,14.79-44,14.79"
      />
      <path class="cls-1" d="M80,25V68H92v34.5L120,56H104l16-31Z" />
    </g>
  </svg>
</template>

<script>
export default {
  name: "HydroIcon",
};
</script>

<style scoped>
.cls-1 {
  fill: none;
  stroke: currentColor;
  stroke-miterlimit: 10;
  stroke-width: 10px;
}
</style>
